/**
 * Registry of active upload/preview WaveSurfer players (PreviewRegionSelector).
 * Stopped when user saves, navigates away, or plays a track in the global footer player.
 */

const activeStoppers = new Set();

export function registerUploadPreviewPlayback(stopFn) {
  if (typeof stopFn !== 'function') {
    return () => {};
  }
  activeStoppers.add(stopFn);
  return () => {
    activeStoppers.delete(stopFn);
  };
}

export function stopAllUploadPreviewPlayback() {
  activeStoppers.forEach((stopFn) => {
    try {
      stopFn();
    } catch {
      // ignore
    }
  });
}

/** Legacy refs on window from UnifiedTrackManager */
export function stopPreviewRegionRefs() {
  if (typeof window === 'undefined') return;
  const refs = window.previewRegionRefs;
  if (!refs || typeof refs !== 'object') return;
  Object.values(refs).forEach((ref) => {
    try {
      ref?.stop?.();
    } catch {
      // ignore
    }
  });
  window.previewRegionRefs = {};
}
